import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
})
export class NavHeaderComponent {}
